var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1429 15.4999C30.1429 7.26835 23.5746 0.595703 15.4719 0.595703C7.36908 0.595703 0.800781 7.26835 0.800781 15.4999C0.800781 22.9387 6.16496 29.1057 13.1788 30.223V19.8077H9.45346V15.4999H13.1788V12.2165C13.1788 8.48056 15.3697 6.41826 18.7212 6.41826C20.3274 6.41826 22.0054 6.70972 22.0054 6.70972V10.3773H20.1557C18.3344 10.3773 17.7649 11.5254 17.7649 12.7045V15.4999H21.8337L21.1838 19.8077H17.7649V30.223C24.7766 29.1035 30.1429 22.9387 30.1429 15.4999Z",
    fill: "#010201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1818 19.8077L21.8317 15.4998H17.7629V12.7045C17.7629 11.5254 18.3323 10.3772 20.1537 10.3772H22.0034V6.70747C22.0034 6.70747 20.3254 6.41602 18.7192 6.41602C15.3677 6.41602 13.1768 8.47831 13.1768 12.2143V15.4976H9.45361V19.8055H13.179V30.2207C13.9267 30.34 14.6917 30.4018 15.472 30.4018C16.2523 30.4018 17.0174 30.34 17.7651 30.2207V19.8055H21.1818V19.8077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbCircle);
export default __webpack_public_path__ + "static/media/fb_circle.1ceb9ccaa3622c5721d8816c2abed83e.svg";
export { ForwardRef as ReactComponent };